import React from "react";
import { LayoutDashboard } from "lucide-react";
import { useDashTheme } from "../hooks/useDashTheme";
import { SectionCard, Button as DashButton } from "../components/primitives";
import { DashboardWidgetToggles } from "../components/DashboardWidgetToggles";
import { useDashboardLayout } from "../hooks/useDashboardLayout";

export default function DashboardLayoutSettings() {
  const t = useDashTheme();
  const { widgets, loading, saving, setWidget, reset } = useDashboardLayout();

  if (loading) {
    return <div style={{ color: t.c.textSecondary, fontSize: 13, padding: 8 }}>Loading…</div>;
  }

  return (
    <div style={{ display: "grid", gap: 16 }}>
      <SectionCard
        title="Dashboard cards"
        subtitle="Same switches as the Customize button on the dashboard. Everyone in the org sees this layout."
        icon={<LayoutDashboard size={14} />}
        actions={
          <DashButton size="sm" variant="ghost" disabled={saving} onClick={reset}>
            Show all
          </DashButton>
        }
      >
        <div style={{ padding: 16 }}>
          <DashboardWidgetToggles widgets={widgets} onToggle={setWidget} disabled={saving} />
        </div>
      </SectionCard>
    </div>
  );
}
